// extracted by mini-css-extract-plugin
export var background = "slidew-module--background---qpvg";
export var grid = "slidew-module--grid--EJo7h";
export var textarea = "slidew-module--textarea--v0RwI";